import React, { useState } from 'react';
import { Box } from '@mui/material';
import useLoginStyles from '../../styles/perfectMatch/perfectMatchLogin';
import logoText from '../../assets/images/perfect_match/logo.jpg';
import promoalcool from '../../assets/images/promo-despre-alcool.png';

interface PerfectMatchLoginProps {
    onLogin: (username: string, password: string) => void;
    loading: boolean;
    error: string | null;
}

const PerfectMatchLogin: React.FC<PerfectMatchLoginProps> = ({ onLogin, loading, error }) => {
    const classes = useLoginStyles();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onLogin(username, password);
    };

    return (
        <Box className={classes.container}>
            <Box
                component="form"
                onSubmit={handleSubmit}
                className={classes.formContainer}
            >
                <img
                    src={logoText}
                    alt="Perfect Match"
                    className={classes.logoImage}
                />

                <h1 className={classes.title}>Perfect Match</h1>
                <p className={classes.subtitle}>Autentificare</p>

                <Box className={classes.inputContainer}>
                    <Box className={classes.inputWrapper}>
                        <label className={classes.label} htmlFor="username">
                            Utilizator
                        </label>
                        <input
                            id="username"
                            type="text"
                            className={classes.input}
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Introdu utilizatorul"
                            required
                            disabled={loading}
                        />
                    </Box>

                    <Box className={classes.inputWrapper}>
                        <label className={classes.label} htmlFor="password">
                            Parolă
                        </label>
                        <input
                            id="password"
                            type="password"
                            className={classes.input}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Introdu parola"
                            required
                            disabled={loading}
                        />
                    </Box>
                </Box>

                {error && (
                    <p className={classes.errorText}>
                        {error}
                    </p>
                )}

                <button
                    type="submit"
                    className={classes.submitButton}
                    disabled={loading}
                >
                    {loading ? 'Se încarcă...' : 'Autentificare'}
                </button>
                 <img
                    src={promoalcool}
                    alt="Promo Alcool"
                    className={classes.logoImage}
                />

            </Box>
        </Box>
    );
};

export default PerfectMatchLogin;